/* @generated */

// src/assets/ui-icon/fill/person-multiple.tsx
import * as React from "react";
var PersonMultipleFill = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M8.059 15.5a4.865 4.865 0 0 1 2.628-2.511.13.13 0 0 0 .079-.143 6.685 6.685 0 0 1-.103-1.2c0-1.015.198-2.002.704-2.821.193-.313.385-.635.43-1 .027-.213.04-.44.04-.679C11.837 5.117 10.874 4 9.125 4S6.413 5.117 6.413 7.146c0 1.124.296 1.966.857 2.496h-.532a3.367 3.367 0 0 0-3.363 3.363V15.5h4.684Zm8.671-1.358h.532a3.367 3.367 0 0 1 3.363 3.363V20h-11.5v-2.495a3.367 3.367 0 0 1 3.363-3.363h.532c-.56-.53-.857-1.372-.857-2.496 0-2.029.963-3.146 2.712-3.146s2.712 1.117 2.712 3.146c0 1.124-.297 1.966-.857 2.495Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  PersonMultipleFill
};
